export default __webpack_public_path__ + "static/media/bnr4.fb6dde9d.jpg";